import { NewplaPageUtils } from '@newpla/ng-common';

/**
 * 화면 로딩 지연. 화면을 열 때 browserNgOnInit에서 기다리는 시간을 한 곳에서 정한다.
 * 모든 앱·환경이 같은 값을 쓴다. 앱이나 환경마다 달라져야 하면 SlsNovaEnv로 나눈다. (OVW-ARC-003 3.1)
 */
export abstract class SlsNovaPageLoading {
  /** 기다리는 시간 (ms) */
  static delayMs = 250;

  static wait() {
    return NewplaPageUtils.wait(SlsNovaPageLoading.delayMs);
  }
}
